// =========================================
// 共通処理
// =========================================
const API_BASE = `https://${window.location.hostname}/apps/shoplist`;
const ROUTES = {
  shops: "/pages/shops",
  shopsList: "/pages/shops-list",
  shopsDetail: "/pages/shops-detail",
};

async function fetchApi(endpoint) {
  const res = await fetch(`${API_BASE}${endpoint}`);
  if (!res.ok) throw new Error(`API Error: ${res.status}`);
  const json = await res.json();
  return json.data;
}

function getCdnImageUrl(filename) {
  if (!filename) return "";
  return `https://${window.location.hostname}/cdn/shop/files/${filename}`;
}

function shopDetailUrl(slug) {
  return `${ROUTES.shopsDetail}/${slug}`;
}

function shopCard(shop, showRegion = false) {
  const regionHtml = showRegion && shop.region
    ? `<p class="store-item__region">${shop.region.name}</p>`
    : '';
  return `
    <li>
      <a href="${shopDetailUrl(shop.slug)}">
        <div class="store-item">
          <div class="store-item__image">
            <img src="${getCdnImageUrl(shop.main_image_cdn_path)}" alt="${shop.name}" loading="lazy">
          </div>
          <p class="store-item__name">${shop.name}</p>
          ${regionHtml}
        </div>
      </a>
    </li>
  `;
}

// =========================================
// ページ判定・初期化
// =========================================
document.addEventListener("DOMContentLoaded", async () => {
  if (document.getElementById("recommended-shops")) {
    initShopsTop();
  } else if (document.getElementById("shop-list")) {
    initShopsList();
  } else if (document.getElementById("shops-detail")) {
    initShopDetail();
  }
});

// =========================================
// Page 1：トップページ
// =========================================
async function initShopsTop() {
  const [shopsData, regions, tags] = await Promise.all([
    fetchApi("/shops?recommended=true"),
    fetchApi("/regions"),
    fetchApi("/tags"),
  ]);

  renderRecommendedShops(shopsData.shops);
  renderRegionDropdown("region-select", regions, null);
  renderTagChips("tag-chips", tags, []);

  document.getElementById("search-form").addEventListener("submit", (e) => {
    e.preventDefault();
    const form = e.target;
    const params = new URLSearchParams();

    const q = form.querySelector('[name="q"]').value.trim();
    if (q) params.set("q", q);

    const region = form.querySelector('[name="region"]').value;
    if (region) params.set("region", region);

    form.querySelectorAll('[name="tags[]"]:checked').forEach((el) => {
      params.append("tags[]", el.value);
    });

    window.location.href = `/pages/shops-list?${params.toString()}`;
  });
}

function renderRecommendedShops(shops) {
  const container = document.getElementById("recommended-shops");
  const left = shops.find((s) => s.recommended === "LEFT");
  const right = shops.find((s) => s.recommended === "RIGHT");

  const items = [];
  if (left)  items.push(shopCard(left));
  if (right) items.push(shopCard(right));
  container.innerHTML = items.join("");
}

// =========================================
// Page 2：検索結果ページ
// =========================================
let _regions = [];
let _tags = [];
let _selectedTags = [];

const PREFECTURE_BY_REGION = {
  kanto:  ["東京都", "埼玉県", "神奈川県", "茨城県", "千葉県"],
  kansai: ["大阪府", "兵庫県", "京都府", "奈良県"],
};

async function initShopsList() {
  const urlParams = new URLSearchParams(window.location.search);
  const currentRegion     = urlParams.get("region");
  const currentPrefecture = urlParams.get("prefecture");

  const [regions, tags, shopsData] = await Promise.all([
    fetchApi("/regions"),
    fetchApi("/tags"),
    fetchApi(`/shops?${urlParams.toString()}`),
  ]);

  _regions = regions;
  _tags = tags;
  _selectedTags = urlParams.getAll("tags[]");

  // フィルタートリガー：現在のキーワードをセット＆クリックでモーダル開く
  // ※ rendering より先に登録して、描画エラーがあっても UI が壊れないようにする
  const filterTrigger = document.getElementById("filter-trigger");
  if (filterTrigger) {
    filterTrigger.value = urlParams.get("q") || "";
    filterTrigger.addEventListener("click", openFilterModal);
  }

  // モーダル内フォームに現在値をセット
  const modalInput = document.getElementById("modal-search-input");
  if (modalInput) modalInput.value = urlParams.get("q") || "";

  renderRegionDropdown("modal-region-select", regions, currentRegion);
  renderTagChips("modal-tag-chips", tags, _selectedTags);
  renderQuickTagChips();

  renderShopList(shopsData.shops);

  // モーダルの開閉
  document
    .getElementById("filter-modal-close")
    ?.addEventListener("click", closeFilterModal);
  document.getElementById("filter-modal")?.addEventListener("click", (e) => {
    if (e.target === e.currentTarget) closeFilterModal();
  });

  // リセット時にエリア・タグを再レンダリング（selected/checked属性によるリセット戻りを防ぐ）
  document.getElementById("filter-form")?.addEventListener("reset", () => {
    setTimeout(() => {
      const regionSelect = document.getElementById("modal-region-select");
      if (regionSelect) regionSelect.value = "";
      renderTagChips("modal-tag-chips", _tags, []);
    }, 0);
  });

  // フィルターフォーム送信
  document
    .getElementById("filter-form")
    ?.addEventListener("submit", async (e) => {
      e.preventDefault();
      const form = e.target;
      const params = new URLSearchParams();

      const q = form.querySelector('[name="q"]').value.trim();
      if (q) params.set("q", q);

      const region = form.querySelector('[name="region"]').value;
      if (region) params.set("region", region);

      form.querySelectorAll('[name="tags[]"]:checked').forEach((el) => {
        params.append("tags[]", el.value);
      });

      window.history.pushState({}, "", `?${params.toString()}`);
      closeFilterModal();

      _selectedTags = params.getAll("tags[]");
      if (filterTrigger) filterTrigger.value = q;
      renderQuickTagChips();

      const result = await fetchApi(`/shops?${params.toString()}`);
      renderShopList(result.shops);
    });
}

function openFilterModal() {
  const modal = document.getElementById("filter-modal");
  if (modal) {
    modal.style.display = "flex";
    document.body.style.overflow = "hidden";
  }
}

function closeFilterModal() {
  const modal = document.getElementById("filter-modal");
  if (modal) {
    modal.style.display = "none";
    document.body.style.overflow = "";
  }
}


function renderShopList(shops) {
  const container = document.getElementById("shop-list");
  if (!container) return;

  if (shops.length === 0) {
    container.innerHTML = '<li class="store-list__empty"><p>該当する店舗が見つかりませんでした。</p></li>';
    return;
  }

  const urlPrefecture = new URLSearchParams(window.location.search).get("prefecture") || "";

  const html = _regions
    .filter((region) => shops.some((s) => s.region.code === region.code))
    .map((region) => {
      const regionShops = shops.filter((s) => s.region.code === region.code);
      const prefectures = PREFECTURE_BY_REGION[region.code];
      const activePref = prefectures?.includes(urlPrefecture) ? urlPrefecture : "";
      const displayShops = activePref
        ? regionShops.filter((s) => s.prefecture?.ken === activePref)
        : regionShops;

      const prefTabsHtml = prefectures
        ? `<nav class="prefecture-tabs" data-region="${region.code}">
            <button type="button" class="prefecture-tab${!activePref ? " prefecture-tab--active" : ""}" data-pref="">すべて</button>
            ${prefectures.map((p) => `<button type="button" class="prefecture-tab${activePref === p ? " prefecture-tab--active" : ""}" data-pref="${p}">${p.replace(/[都道府県]$/, "")}</button>`).join("")}
           </nav>`
        : "";

      return `
        <li class="accordion" data-accordion>
          <button class="accordion__button accordion__button--has-icon" type="button" aria-expanded="true" data-accordion-trigger>
            <span>${region.name}</span>
          </button>
          <div class="accordion__content" data-accordion-content style="display:flex;">
            <div class="container gap-40 lg:gap-30 mt-20 lg:mt-30 pb-50 lg:pb-80">
              ${prefTabsHtml}
              <ul class="store-list__list" data-region-shops="${region.code}">
                ${displayShops.map((shop) => shopCard(shop)).join("")}
              </ul>
            </div>
          </div>
        </li>
      `;
    });

  container.innerHTML = html.join("");

  // 都道府県タブの絞り込み（クライアントサイド）
  container.querySelectorAll(".prefecture-tabs").forEach((tabNav) => {
    const regionCode = tabNav.dataset.region;
    const shopList = container.querySelector(`[data-region-shops="${regionCode}"]`);
    const regionShops = shops.filter((s) => s.region.code === regionCode);

    tabNav.querySelectorAll(".prefecture-tab").forEach((btn) => {
      btn.addEventListener("click", () => {
        tabNav.querySelectorAll(".prefecture-tab").forEach((b) => b.classList.remove("prefecture-tab--active"));
        btn.classList.add("prefecture-tab--active");

        const pref = btn.dataset.pref;
        const filtered = pref ? regionShops.filter((s) => s.prefecture?.ken === pref) : regionShops;
        shopList.innerHTML = filtered.map((shop) => shopCard(shop)).join("");
      });
    });
  });

  // アコーディオントグル
  container.querySelectorAll("[data-accordion-trigger]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const content = btn.parentElement.querySelector("[data-accordion-content]");
      const isOpen = btn.getAttribute("aria-expanded") === "true";
      btn.setAttribute("aria-expanded", String(!isOpen));
      content.style.display = isOpen ? "none" : "flex";
    });
  });
}

// =========================================
// Page 3：店舗詳細ページ
// =========================================
function getShopDetailSlugFromPath() {
  const path = window.location.pathname.replace(/\/+$/, "") || "/";
  const base = ROUTES.shopsDetail;

  if (!path.startsWith(base)) return null;

  const suffix = path.slice(base.length).replace(/^\//, "");

  if (!suffix) return null;

  const segment = suffix.split("/")[0];

  return segment || null;
}

async function initShopDetail() {
  const slug = getShopDetailSlugFromPath();
  const container = document.getElementById("shops-detail");

  if (!slug) {
    container.innerHTML =
      '<p style="text-align:center;padding:60px 0;">店舗が指定されていません。</p>';
    return;
  }

  // 店舗サービス一覧：テーマ側の固定値として管理（API動的取得は行わない設計）
  const STATIC_SERVICE_LIST = [
    {
      name: "イベント",
      label: "イベント",
      description:
        "お子様がご参加いただけるワークショップなど、各種イベントを開催しております。",
    },
    {
      name: "マタニティセミナー",
      label: "マタニティ<br>セミナー",
      description:
        "肌着の着せ方やおむつのこと、沐浴の仕方など、実際に体感いただけるセミナーを開催しております。",
    },
    {
      name: "保険",
      label: "保険",
      description:
        "ファミリアスタッフによる個別相談会を開催しております。事前予約のうえ、ご来店ください。<br>ご契約でオリジナルポーチをプレゼント。",
    },
    {
      name: "カプセルトイ",
      label: "カプセル<br>トイ",
      description:
        "カプセルトイを設置している店舗となります。在庫状況や内容につきましては各ショップへご確認ください。",
    },
    {
      name: "ギフト交換対応可能",
      label: "ギフト交換<br>対応可能",
      description:
        "「返品・交換不可製品」に該当しない製品のサイズ交換のみ対応可能です。製品を確認の上、弊社基準に基づきお承りいたします。",
    },
    {
      name: "駐車場",
      label: "駐車場",
      description:
        "駐車場または提携駐車場がございます。ショップにより契約内容が異なりますので、詳しくは各ショップにご確認ください。",
    },
    {
      name: "免税",
      label: "免税",
      description:
        "免税サービスがご利用いただけます（免税対象店舗準備中）。百貨店内での免税サービスについては、各ショップにご確認ください。",
    },
  ];

  try {
    const shop = await fetchApi(`/shops/${slug}`);
    renderShopDetail(shop, STATIC_SERVICE_LIST);
  } catch {
    container.innerHTML =
      '<p style="text-align:center;padding:60px 0;">店舗情報が見つかりませんでした。</p>';
  }
}

function renderShopDetail(shop, allTags) {
  const displayServices = allTags.filter((s) =>
    (shop.tags || []).includes(s.name),
  );

  const icons = window.__shopIcons || {};
  const iconImg = (type, alt) =>
    icons[type]
      ? `<img width="18" height="18" src="${icons[type]}" alt="${alt}">`
      : `<span>${alt}</span>`;

  // メイン画像 + スライダー画像を結合
  const allImages = [
    shop.main_image_cdn_path,
    ...(shop.slider_images || []),
  ].filter(Boolean);

  const slides = allImages
    .map(
      (img) =>
        `<li class="swiper-slide"><img src="${getCdnImageUrl(img)}" alt="${shop.name}"></li>`,
    )
    .join("");

  const container = document.getElementById("shops-detail");
  container.innerHTML = `
    <div class="container gap-30 lg:gap-65">
      <h1 class="store__name">${shop.name}</h1>

      <div class="store__carousel-container">
        <button class="store__carousel-left-button" type="button"></button>
        <div class="store__carousel swiper" id="shop-swiper">
          <ul class="swiper-wrapper">${slides}</ul>
          <div class="store__carousel-pagination swiper-pagination"></div>
        </div>
        <button class="store__carousel-right-button" type="button"></button>
      </div>

      <div class="store__info">
        <dl>
          <dt>${iconImg("address", "住所")}</dt>
          <dd>
            <a target="_blank" href="${shop.google_maps_link}">
              <p>〒${shop.postal_code}<br>${shop.address}</p>
            </a>
          </dd>
          ${
            shop.phone
              ? `
          <dt>${iconImg("tel", "電話番号")}</dt>
          <dd><a class="tel-link" href="tel:${shop.phone}">${shop.phone}</a></dd>
          `
              : ""
          }
          ${
            shop.opening_times
              ? `
          <dt>${iconImg("hours", "営業時間")}</dt>
          <dd>${shop.opening_times}</dd>
          `
              : ""
          }
          ${
            shop.holiday_and_leave
              ? `
          <dt>${iconImg("calendar", "定休日")}</dt>
          <dd>${shop.holiday_and_leave}</dd>
          `
              : ""
          }
          ${
            shop.access
              ? `
          <dt>${iconImg("access", "アクセス")}</dt>
          <dd>${shop.access}</dd>
          `
              : ""
          }
        </dl>
        <hr>
      </div>

      <div class="store__available-services">
        <div class="store__available-services-title">
          <span>受けられるサービス</span>
          <button id="service-list-btn" type="button">店舗サービス一覧</button>
        </div>
        ${
          displayServices.length > 0
            ? `
          <ul>
            ${displayServices.map((s) => `<li>${s.label}</li>`).join("")}
          </ul>
        `
            : `<ul><li>サービス<br>準備中</li></ul>`
        }
      </div>

      ${
        shop.banner_display
          ? `
        <div class="store__banner">
          <section class="link-image">
            <a href="${shop.banner_url}" target="_blank">
              <div class="tagged-image">
                <img src="${getCdnImageUrl(shop.banner_image_cdn_path)}" alt="${shop.banner_hashtag}">
                <span class="tag tag--small">#${shop.banner_hashtag}</span>
              </div>
            </a>
          </section>
        </div>
      `
          : ""
      }

      <hr>

      <div class="store__footer">
        <a class="button button--has-icon-arrow-left" href="/pages/shops">
          ショップ一覧へもどる
        </a>
      </div>
    </div>
  `;

  if (allImages.length > 0 && typeof Swiper !== "undefined") {
    new Swiper("#shop-swiper", {
      loop: false,
      navigation: {
        prevEl: ".store__carousel-left-button",
        nextEl: ".store__carousel-right-button",
      },
      pagination: {
        el: ".store__carousel-pagination",
        clickable: true,
      },
    });
  }

  const serviceBtn = document.getElementById("service-list-btn");
  if (serviceBtn && allTags && allTags.length > 0) {
    serviceBtn.addEventListener("click", () => openServiceModal(allTags));
  }
}

function openServiceModal(allTags) {
  const existing = document.getElementById("shop-service-modal");
  if (existing) {
    existing.style.display = "flex";
    document.body.style.overflow = "hidden";
    return;
  }

  const overlay = document.createElement("div");
  overlay.id = "shop-service-modal";
  overlay.className = "shop-service-modal";
  overlay.innerHTML = `
    <div class="shop-service-modal__dialog">
      <button class="shop-service-modal__close" type="button" aria-label="閉じる">
        <svg fill="none" height="50" viewBox="0 0 50 50" width="50" xmlns="http://www.w3.org/2000/svg">
          <path d="M38 38L25 25M25 25L38 12M25 25L12 38M25 25L12 12" stroke="#555555" stroke-opacity="0.5" stroke-width="2"></path>
        </svg>
      </button>
      <div class="shop-service-modal__body">
        <h2 class="shop-service-modal__title">店舗サービス一覧</h2>
        <ul class="shop-service-modal__list">
          ${allTags
            .map(
              (tag) => `
            <li class="shop-service-modal__item">
              <div class="shop-service-modal__icon">${tag.label ?? tag.name ?? tag}</div>
              <p class="shop-service-modal__desc">${tag.description ?? ""}</p>
            </li>
          `,
            )
            .join("")}
        </ul>
      </div>
    </div>
  `;

  document.body.appendChild(overlay);
  overlay.style.display = "flex";
  document.body.style.overflow = "hidden";

  overlay
    .querySelector(".shop-service-modal__close")
    .addEventListener("click", closeServiceModal);
  overlay.addEventListener("click", (e) => {
    if (e.target === overlay) closeServiceModal();
  });
}

function closeServiceModal() {
  const overlay = document.getElementById("shop-service-modal");
  if (overlay) {
    overlay.style.display = "none";
    document.body.style.overflow = "";
  }
}

// =========================================
// 共通UI部品
// =========================================
function renderRegionDropdown(selectId, regions, selected) {
  const select = document.getElementById(selectId);
  if (!select) return;
  regions.forEach((r) => {
    select.innerHTML += `<option value="${r.code}" ${r.code === selected ? "selected" : ""}>${r.name}</option>`;
  });
}

function renderQuickTagChips() {
  const container = document.getElementById("quick-tag-chips");
  if (!container || !Array.isArray(_tags)) return;
  container.innerHTML = _tags
    .map(
      (tag) => `
      <li>
        <button type="button" class="tag tag--large${_selectedTags.includes(tag) ? " tag--active" : ""}"
                data-quick-tag="${tag}">${tag}</button>
      </li>
    `,
    )
    .join("");

  container.querySelectorAll("[data-quick-tag]").forEach((btn) => {
    btn.addEventListener("click", () => handleQuickTagClick(btn.dataset.quickTag));
  });
}

async function handleQuickTagClick(tag) {
  if (_selectedTags.includes(tag)) {
    _selectedTags = _selectedTags.filter((t) => t !== tag);
  } else {
    _selectedTags = [..._selectedTags, tag];
  }

  const params = new URLSearchParams(window.location.search);
  params.delete("tags[]");
  _selectedTags.forEach((t) => params.append("tags[]", t));
  window.history.pushState({}, "", `?${params.toString()}`);

  renderQuickTagChips();
  renderTagChips("modal-tag-chips", _tags, _selectedTags);

  const result = await fetchApi(`/shops?${params.toString()}`);
  renderShopList(result.shops);
}

function renderTagChips(containerId, tags, selected) {
  const container = document.getElementById(containerId);
  if (!container) return;
  container.innerHTML = tags
    .map(
      (tag) => `
      <li>
        <label class="tag tag--large">
          <input type="checkbox" name="tags[]" value="${tag}" ${selected.includes(tag) ? "checked" : ""}>
          <span>${tag}</span>
        </label>
      </li>
    `,
    )
    .join("");
}
